export const sexOptions = [
  {
    label: '男',
    value: 1
  },
  {
    label: '女',
    value: -1
  },
]

export const studentStatusOptions = [
  {
    label: '在校',
    value: 'ON'
  },
  {
    label: '毕业',
    value: 'OFF'
  },
  {
    label: '肄业',
    value: 'DROP_OUT'
  },
  {
    label: '结业',
    value: 'GRADUATION'
  },
]

export const checkStatusOptions = [
  {
    label: '未注册',
    value: 0
  },
  {
    label: '已匹配',
    value: 1
  },
  {
    label: '姓名错误',
    value: 2
  },
]

export const eventTypeOptions = [
  {
    label: '社会活动',
    value: 'SOCIOLOGY'
  },
  {
    label: '学院活动',
    value: 'BUSINESS'
  }
]

export const staffEventTypeOptions = [
  {
    label: '社会活动',
    value: 'SOCIOLOGY'
  },
  {
    label: '机构活动',
    value: 'BUSINESS'
  }
]

export const staffStatusOptions = [
  {
    label: '在职',
    value: 'ON'
  },
  {
    label: '离职',
    value: 'OFF'
  },
]

export const loginFormOptions = [
  {
    homePath: 'personalServicesHome',
    pathName: 'PersonalServices',
    platform: 'CONSUMER',
    roles: ['CONSUMER']
  },
  {
    homePath: 'educationalServicesHome',
    pathName: 'EducationalServices',
    platform: 'BUSINESS',
    roles: ['ACADEMIC_EDUCATION', 'NON_ACADEMIC_EDUCATION']
  },
  {
    homePath: 'employerServicesHome',
    pathName: 'EmployerServices',
    platform: 'BUSINESS',
    roles: ['EMPLOYER']
  },
]
// 专业权限
export const eduPermissionOptions = [4, 6, 8]


// WEBPACK FOOTER //
// ./src/utils/define.js